export default "__VITE_ASSET__8LVgRnQn__"